import dayjs from "dayjs";

import { tableSimpleSort } from "@similarweb/pro-logic-components";

import type { IModifiablePrompt } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/prompts-report/edit-modal/types";

export const getColumnSorter = (
    key: keyof IModifiablePrompt,
): ((a: IModifiablePrompt, b: IModifiablePrompt) => number) => {
    switch (key) {
        case "timestamp":
            return (a, b) => (dayjs(a.timestamp).isAfter(dayjs(b.timestamp)) ? -1 : 1);

        default:
            return tableSimpleSort(key);
    }
};
